import {assign} from 'xstate'
import ApiFetcher from 'lib/api_fetcher'
import moment from 'moment'
import {nextStep} from 'utils/step_utils'
import i18n from 'i18n/config'

const stepName  = 'couponStep'

const setFetchingError = assign({error: i18n.t('validations:coupon_fetch_error')})
const setInvalidCouponError = assign({error: i18n.t('validations:coupon_invalid_error')})
const setCoupon = assign({coupon: (ctx, e) => {
  return e.data.data.DiscountCoupons[0].Code
}})
const cleanError = assign({error: null})
const updateCoupon = assign({coupon: (ctx, e) => e.coupon})

const fetchCoupon = (ctx) => {
  const body = JSON.stringify({coupon_id: ctx.coupon})

  return (
    new ApiFetcher({
      key: 'coupon',
      endpoint: ctx.endpoints.coupon,
      method: 'post',
      body: body
    }).call()
  )
}

const emptyInput = (ctx, e) => !ctx.coupon
const validCoupon = (ctx, e) => e.data.success

const couponState = (config) => {
  return {
    initial: 'init',
    states: {
      init: {
        on: {'': {
          target: 'waitingCouponInput'
        }},
      },
      waitingCouponInput: {
      },
      prepareFetchingCoupon: {
        on: {'': {
          target: 'fetchingCoupon',
          actions: [cleanError, 'startSpinner']
        }},
      },
      fetchingCoupon: {
        invoke: {
          src: fetchCoupon,
          onDone: [
            {
              target: nextStep(config, stepName) ? `#purchase.${nextStep(config, stepName)}` : '#purchase.reserving',
              cond: validCoupon,
              actions: [setCoupon, 'stopSpinner']
            },
            {
              target: 'waitingCouponInput',
              actions: [setInvalidCouponError, 'stopSpinner']
            }
          ],
          onError: {
            target: 'waitingCouponInput',
            actions: [setFetchingError, 'stopSpinner']
          }
        }
      },
    },
    on: {
      COUPON_CHANGE: {
        actions: [updateCoupon, cleanError]
      },
      NEXT_STEP_CLICK: [
        {
          target: nextStep(config, stepName) ? `#purchase.${nextStep(config, stepName)}` : '#purchase.reserving',
          cond: emptyInput
        },
        {
          target: '.prepareFetchingCoupon',
        }
      ]
    }
  }
}

export default couponState
